<template>
  <div>
    <div class="area w-100 d-none">
      <div class="container">
        <div class="area__box">
          <div class="area__box__title">
            Localização <b>Privilegiada</b>
          </div>
          <div class="area__box__lead">
            {{location.address}}
          </div>
          <div class="area__box__chegar">
            Não sabe chegar?
          </div>
          <div class="area__box__form">
            <form v-on:submit.prevent="alteraEndereco(novoEndereco)">
              <input v-model="novoEndereco" type="text" class="w-100" placeholder="Digite seu endereço" required>
              <button type="submit" :disabled="disabledRota">
                {{textRota}}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div id="mapa" class="mapa" v-if="showMap">
      <InternaMapa
      :enable-infowindow="true"
      :zoom="14"
      css="width:100%;height:100%;"
      :points="pontos"
      :latitude="location.latitude"
      :longitude="location.longitude"
      :code="codePoint"
      :endereco="endereco"
      @liberaRota="liberaRota">
      </InternaMapa>
    </div>
    <div class="local__itens">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-2 col-12">
            <div class="local__subtitle">
              Nesta área:
            </div>
          </div>
          <div class="col-md-10 col-12">
            <carousel
              :per-page="1"
              :paginationPadding="5"
              :paginationSize="15"
              :paginationActiveColor="'#13182c'"
              :perPageCustom="[[480, 1], [768, 3], [1024, 4], [1200, 5]]"
              :loop="true"
              :autoplay="false"
              :paginationEnabled="true">
              <slide v-for="(item,index) in arrayLocais" :key="index">
                <div class="local__slide" :class="{'local__active' : tab.indexOf(item.code) != -1}" @click="aciveCategoria(index)">
                  <img :src="item.imagem" :alt="item.nome"> {{item.nome}}
                </div>
              </slide>
            </carousel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Carousel, Slide } from 'vue-carousel'
import InternaMapa from './InternaMapa.vue'
export default {
  data () {
    return {
      pontos: [],
      showMap: false,
      tab: [],
      codePoint: '',
      endereco: null,
      novoEndereco: '',
      disabledRota: false,
      textRota: 'Traçar rota',
      arrayLocais: [
        {
          'id': '1',
          'imagem': '../../static/icon-lazer.png',
          'nome': 'Lazer',
          'code': 'recreation'
        },
        {
          'id': '2',
          'imagem': '../../static/icon-educacao.png',
          'nome': 'Educação',
          'code': 'education'
        },
        {
          'id': '3',
          'imagem': '../../static/icon-saude.png',
          'nome': 'Saúde',
          'code': 'health'
        },
        {
          'id': '4',
          'imagem': '../../static/icon-alimentacao.png',
          'nome': 'Alimentação',
          'code': 'food'
        },
        {
          'id': '5',
          'imagem': '../../static/icon-conforto.png',
          'nome': 'Conforto',
          'code': 'comfort'
        }
      ],
      mapCharacteristics: ''
    }
  },
  props: ['location'],
  name: 'Mapa',
  components: {
    Carousel,
    Slide,
    InternaMapa
  },
  mounted () {
    this.mapCharacteristics = this.mountMapBoxHtml(this.location.main_characteristics)
    this._createPoints()
  },
  methods: {
    mountMapBoxHtml (characteristics) {
      let html = ``
      for (var i = 0; i < characteristics.length; i++) {
        html += `
          <li style="width: 50%" class="float-left">
            <img src="${characteristics[i].image}" style="width: 28px"> ${characteristics[i].title}
          </li>`
      }
      return html
    },
    liberaRota () {
      this.disabledRota = false
      this.textRota = 'Traçar rota'
    },
    alteraEndereco (newEndereco) {
      this.endereco = newEndereco
      this.disabledRota = true
      this.textRota = 'Procurando'
    },
    aciveCategoria (a) {
      let index = this.tab.indexOf(this.arrayLocais[a].code)
      if (index === -1) {
        this.tab.push(this.arrayLocais[a].code)
        setTimeout(() => {
          this.codePoint = this.arrayLocais[a].code
        })
        this.codePoint = null
      } else {
        this.tab.splice(index, 1)
        setTimeout(() => {
          this.codePoint = this.arrayLocais[a].code
        })
        this.codePoint = null
      }
    },
    _createPoints () {
      let points = []
      points.push({
        title: `
            <div style="width: 100px; margin: 0px" class="float-left">
              <img class="img-fluid" style="max-width:100px!important" src="${this.location.image}">
            </div>
            <div style="width: 260px; padding-left: 15px; " class="float-left business_details">
              <h3>
                ${this.location.title}
              </h3>
              <ul class="float-left w-100">
                ${this.mapCharacteristics}
              </ul>
              <p v-if="${this.location.address}">
                ${this.location.address}
              </p>
              <span v-if="${this.location.reference}">
                ${this.location.reference}
              </span>
            </div>
        `,
        latitude: this.location.latitude,
        longitude: this.location.longitude,
        icon: '../../static/icon-empreedimento.png'
      })
      if (this.location.suroundings.length > 0) {
        this.location.suroundings.forEach((around) => {
          let icon = ''
          around.title = around.name
          switch (around.type) {
            case 'recreation':
              icon = '../../static/recreation.png'
              break
            case 'education':
              icon = '../../static/education.png'
              break
            case 'health':
              icon = '../../static/health.png'
              break
            case 'food':
              icon = '../../static/food.png'
              break
            case 'comfort':
              icon = '../../static/comfort.png'
              break
            default:
              icon = '../../static/icon-empreedimento.png'
              break
          }
          around.icon = icon
          points.push(around)
        })
      }
      this.pontos = points
      this.showMap = true
    }
  }
}
</script>
<style lang="scss">
@import '../../assets/scss/_variables.scss';
.gm-style-iw {
  border-radius: 5px 5px 5px 5px;
  background: #FFF;
  width: 100% !important;
  padding: 0px !important;
  margin: 0px !important;
  overflow: hidden !important;
  height: 150px !important;
  left: 0px !important;
  top: 0px !important;
  :nth-child(1){
    overflow: hidden !important;
    display: inline-block !important;
    padding: 0px !important;
    margin: 0px !important;
  }
}
.business_details{
  h3{
    color: $yellow;
    margin-top: 5px !important;
    font-size: 16px !important;
    font-weight: 600;
    text-align: left;
  }
  p{
    font-weight: 400;
    font-size: 13px;
    color: $silver;
    float: left;
    text-align: left;
    width: 100%;
  }
  span{
    font-weight: 400;
    font-size: 13px;
    color: $yellow;
    width: 100%;
    text-align: left;
    float: left;
  }
  ul{
    margin-bottom: 5px;
    li{
      font-weight: 400;
      font-size: 13px;
      color: $silver;
      text-align: left;
    }
  }
}
.local {
  &__active {
    font-weight: 400!important;
    opacity: 1!important;
    position: relative;
    transition: all 0.3s;
    &:after {
      bottom: -1px;
      content: '';
      left: calc(50% - 45px);
      position: absolute;
      background: $green;
      height: 9px;
      width: 90px;
    }
  }
}
.local__itens {
  background: $primary;
}
.local__slide {
  color: white;
  cursor: pointer;
  font-weight: 300;
  opacity: 0.6;
  padding: 50px 0;
  text-align: center;
  text-transform: uppercase;
  transition: all 0.3s;
  img {
    margin-right: 10px;
  }
  &:hover {
    color: $green;
    transition: all 0.3s;
  }
  @media (max-width: 991px){
    padding: 30px 0;
  }
}
.local__subtitle {
  color: white;
  font-size: 18px;
  font-weight: 900;
  text-transform: uppercase;
  @media (max-width: 767px){
    padding-top: 20px;
    text-align: center;
  }
}
.mapa{
  height: 100%;
  margin: 0;
  position: relative;
  z-index: 1;
}
.area {
  .container {
    position: relative;
  }
  &__box {
    background: $primary;
    box-shadow: 10px 10px 20px 0px rgba(0, 26, 66, 0.2);
    left: 0;
    padding: 20px;
    position: absolute;
    top: 100px;
    width: 450px;
    z-index: 20;
    &__title {
      color: white;
      font-size: 26px;
      font-weight: 300;
      margin-bottom: 30px;
      text-transform: uppercase;
      b {
        font-weight: 900;
      }
    }
    &__lead {
      color: white;
      font-size: 18px;
      line-height: 20px;
      margin-bottom: 40px;
      max-width: 280px;
    }
    &__chegar {
      color: white;
      font-weight: bold;
      font-size: 20px;
      margin-bottom: 20px;
    }
    &__form {
      position: relative;
      input {
        border: none;
        border-radius: 50px;
        color: $silver;
        font-size: 18px;
        font-style: italic;
        font-weight: 300;
        outline: none;
        padding: 13px 20px;
        width: 100%;
        &:focus {
          outline: none;
        }
      }
      ::-webkit-input-placeholder {
        color: $silver;
        font-size: 18px;
        font-style: italic;
        font-weight: 300;
      }
      ::-moz-placeholder {
        color: $silver;
        font-size: 18px;
        font-style: italic;
        font-weight: 300;
      }
      :-ms-input-placeholder {
        color: $silver;
        font-size: 18px;
        font-style: italic;
        font-weight: 300;
      }
      :-moz-placeholder {
        color: $silver;
        font-size: 18px;
        font-style: italic;
        font-weight: 300;
      }
      button {
        background: $green;
        border: none;
        border-radius: 50px;
        color: white;
        cursor: pointer;
        outline: none;
        padding: 10px 30px;
        position: absolute;
        right: 3px;
        top: 3px;
        &:focus {
          outline: none;
        }
        &:disabled {
          opacity: 0.7;
        }
      }
    }
    @media (max-width: 1400px){
      padding: 20px;
      top: 120px;
      width: 400px;
      &__title {
        font-size: 20px;
      }
      &__lead {
        margin-bottom: 20px;
        max-width: inherit;
        width: 100%;
      }
      &__chegar {
        font-size: 20px;
        margin-bottom: 10px;
      }
    }
    @media (max-width: 991px){
      position: relative;
      top: inherit;
      left: inherit;
      padding: inherit;
      width: 100%;
      *{
        text-align: center;
      }
      &__title {
        line-height: 25px;
        margin-bottom: 10px;
      }
    }
    @media (max-width: 767px){
      button {
        position: relative;
        top: inherit;
        right: inherit;
        width: 100%;
        margin-top: 10px;
      }
    }
  }
  @media (max-width: 991px){
    background: $primary;
    padding: 40px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/empreendimentos/InternaLocalizacaoMapa.vue